export const breakpoints = [480, 768, 1200, 1500]

export const breakpointConstants = {
  sm: 480,
  md: 768,
  lg: 1200,
  x_lg: 1500,
}
